import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33050220"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "addressInput",
  class: "form-label"
}, "Email address", -1))
const _hoisted_3 = ["readonly"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "other-actions" }

import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAppHostStore } from '@webapp/AppHostStore'
import { getSafeRedirectUri, usePageTitle } from '@webapp/util/AppUtil' 
import { useSignInStore } from '@webapp/auth/SignInStore'
import { useIdentityApi } from '@webapp/auth/IdentityApi'
import { AddressUtil } from '@webapp/util/AddressUtil'
import TaskPage from '@webapp/util/TaskPage.vue'
import Spinner from '@webapp/util/Spinner.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SignInPage',
  emits: [
  'useDeviceCode',
  'noAccount'
],
  setup(__props, { emit }) {

usePageTitle("Sign in")



const identityApi = useIdentityApi()
const appHostStore = useAppHostStore()
const signInStore = useSignInStore()
const router = useRouter()

const canEditRef = computed(() => !busyRef.value)
const canSendCodeRef = computed(() => !busyRef.value && AddressUtil.isValidEmail(signInStore.address))
const busyRef = ref(false)

const addressInputRef = ref<HTMLInputElement>()

async function requestCode(e: Event) {
  e.preventDefault()
  busyRef.value = true
  
  await identityApi.sendSignInCodeAsync(signInStore.address)

  busyRef.value = false

  signInStore.isNewUser = false
  
  const redirectUri = getSafeRedirectUri()
  router.push({ path: "/signin/code", query: { redirect_uri: redirectUri } })
}

onMounted(() => {
  addressInputRef.value!.focus()
  addressInputRef.value!.select()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(TaskPage, {
    class: "signin-page",
    "no-title": _unref(appHostStore).isEmbedded,
    "no-back": "",
    "no-action": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode("Sign in")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            id: "addressInput",
            ref_key: "addressInputRef",
            ref: addressInputRef,
            readonly: !canEditRef.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(signInStore).address) = $event))
          }, null, 8, _hoisted_3), [
            [_vModelText, _unref(signInStore).address]
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "submit",
            class: "btn btn-primary",
            disabled: !canSendCodeRef.value,
            onClick: requestCode
          }, [
            (busyRef.value)
              ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
              : _createCommentVNode("", true),
            _createTextVNode(" Send a sign in code ")
          ], 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_unref(appHostStore).isEmbedded)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-inline btn-link",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('useDeviceCode')))
              }, " Use quick sign in "))
            : _createCommentVNode("", true),
          (_unref(appHostStore).isEmbedded)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                class: "btn btn-inline btn-link",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('noAccount')))
              }, " I don't have an account "))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: "/signup"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" I don't have an account ")
                ]),
                _: 1
              }))
        ])
      ])
    ]),
    _: 1
  }, 8, ["no-title"]))
}
}

})